import { makeStyles } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import { AiOutlineInfoCircle } from "react-icons/ai";

export default function CoinDetailStrip({ coin, items, help, onHelpClick }) {
  const classes = useStyles();
  const coinIcons = useSelector((state) => state.trading.COIN_ICONS);
  const currentCoin = coinIcons[coin];

  return currentCoin ? (
    <div
      className={`${classes.wrapper} p-3 flex items-start gap-x-5 justify-evenly relative`}
    >
      <div className="flex gap-x-3">
        <a href="/currency" className="flex justify-center items-center">
          <img
            src={currentCoin?.activeIconUrl}
            height="auto"
            width={26}
            alt={currentCoin}
          />
        </a>
        <div>
          <p>{currentCoin?.coinName}</p>
          <p className="text-gray-400">{currentCoin?.coinId}</p>
        </div>
      </div>
      {items?.map((ele, idx) =>
        ele?.tooltip ? (
          <Tooltip
            className="cursor-pointer"
            title={ele.tooltip}
            placement="top"
            enterTouchDelay={0}
            arrow
          >
            <div>
              <ItemChild label={ele.label} value={ele.value}></ItemChild>
            </div>
          </Tooltip>
        ) : (
          <ItemChild label={ele.label} value={ele.value}></ItemChild>
        )
      )}
      {help && (
        <div onClick={onHelpClick}>
          <AiOutlineInfoCircle className="absolute right-3 top-1 opacity-80"></AiOutlineInfoCircle>
        </div>
      )}
    </div>
  ) : (
    <React.Fragment></React.Fragment>
  );
}

const ItemChild = ({ label, value }) => {
  return (
    <div className="text-center">
      <p className="font-bold">{value}</p>
      <p className="text-gray-400">{label}</p>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: "20px",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow:
      theme.palette.type === "dark"
        ? "37.9444px 56.9167px 189.722px rgba(16, 18, 26, 0.5)"
        : "2px 7px 8px rgba(0, 0, 0, 0.15);",
    lineHeight: "25px",
    background:
      theme.palette.type === "dark"
        ? "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.5) 0%, rgba(36, 38, 43, 0.5) 100%)"
        : "white",
    // minWidth: "450px",
  },
}));
